import '../../css/mk-brand.css';
import {useEffect} from 'react';
import MagicEden from '../../media/promo-sites/magic-eden.png'
import Minty from '../../media/promo-sites/minty.jpeg'
import NFTCalendar from '../../media/promo-sites/nftcalendar-logo.png';
import NFTShill from '../../media/promo-sites/nft-shill.jpeg';
import NFTSniper from '../../media/promo-sites/nft-sniper-logo.png';
import NFTArt from '../../media/promo-sites/nft-art-logo.png';
import NFTCalendarDrop from '../../media/promo-sites/nft-calendar-drop.png';
import NFTSolCalendar from '../../media/promo-sites/nft-sol-calendar.png';
import CrossMint from '../../media/promo-sites/cross-mint.jpeg';
import OpenSea from '../../media/promo-sites/open-sea.png'
function FeaturesAndMarketplaces() {
  useEffect(() => {
  },);
  // @ts-ignore
  return (
    <div id="features-and-marketplaces" className="m-2">
      <div className="container max-w-4xl">
        <div className="p-4">
          <div className="">
            <h1 className="flex justify-center text-2xl md:text-4xl lg:text-6xl font-extrabold mx-auto">Features and Marketplaces</h1>
          </div>
          <div className="container justify-center flex flex-wrap items-center">
            <a className="p-8" href="https://magiceden.io/collections">
              <img className="mx-auto w-24 rounded-lg" alt="Magic Eden link" src={MagicEden} />
            </a>
            <a className="p-8" href="https://docs.opensea.io/">
              <img className="mx-auto w-24 rounded-lg" alt="Open Sea Developers link" src={OpenSea} />
            </a>
            <a className="p-8" href="https://mintyscore.com/project/d1041504-c8ba-41e2-a40e-733bf7697cc7">
              <img className="mx-auto w-24 rounded-lg" alt="Minty Score link" src={Minty} />
            </a>
            <a className="p-8" href="https://nftcalendar.io/event/metakitchen/">
              <img className="mx-auto w-24 rounded-lg" alt="NFT Calendar link" src={NFTCalendar} />
            </a>
            <a className="p-8" href="https://nftsniper.net/collection/sol-metakitchen-nft">
              <img className="mx-auto w-24 rounded-lg" alt="NFT Sniper link" src={NFTSniper} />
            </a>
            <a className="p-8" href="https://nftshill.io/project/metakitchen_">
              <img className="mx-auto w-24 rounded-lg" alt="NFT Shill link" src={NFTShill} />
            </a>
            <a className="p-8" href="https://upcomingnft.art/metakitchen/">
              <img className="mx-auto w-24 rounded-lg" alt="NFT Art link" src={NFTArt} />
            </a>
            <a className="p-8" href="https://www.nftdropscalendar.com/nft-drops/metakitchen">
              <img className="mx-auto h-24 w-24 rounded-lg" alt="NFT Drops Calendar link" src={NFTCalendarDrop} />
            </a>
            <a className="p-8" href="https://nftsolana.io/calendar-nft/metakitchen-nft/">
              <img className="mx-auto w-24 bg-white" alt="NFT SOL Calendar link" src={NFTSolCalendar} />
            </a>
            <a className="p-8" href="https://www.crossmint.io//">
              <img className="mx-auto w-24 bg-white" alt="Cross Mint link" src={CrossMint} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturesAndMarketplaces;

